import { useIsoMorphicEffect as s } from './use-iso-morphic-effect.js';
var u = new Map(),
  t = new Map();
function h(r) {
  var l = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
  s(function () {
    var o;
    if (!l) return;
    var e = typeof r == "function" ? r() : r.current;
    if (!e) return;
    function a() {
      var d;
      if (!e) return;
      var i = (d = t.get(e)) != null ? d : 1;
      if (i === 1 ? t.delete(e) : t.set(e, i - 1), i !== 1) return;
      var n = u.get(e);
      n && (n["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", n["aria-hidden"]), e.inert = n.inert, u.delete(e));
    }
    var f = (o = t.get(e)) != null ? o : 0;
    return t.set(e, f + 1), f !== 0 || (u.set(e, {
      "aria-hidden": e.getAttribute("aria-hidden"),
      inert: e.inert
    }), e.setAttribute("aria-hidden", "true"), e.inert = !0), a;
  }, [r, l]);
}
export { h as useInert };